import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import { SessionContextProvider } from "@supabase/auth-helpers-react";
import { createClient } from '@supabase/supabase-js';


const supabase = createClient("https://nixuroxuajgcyufrngpm.supabase.co", "sb_publishable_vT8lQ2EOcjxXiOWXg9XECA_6SgykTDn");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabase}>
    <BrowserRouter>
    <App />
    </BrowserRouter>
    </SessionContextProvider>
  </React.StrictMode>
);